/**
 * Dispatched initially
 */
export const INIT = "DEVICE_INFO_INIT";

/**
 * Dispatched whenever layout is changed.
 */
export const LAYOUT_CHANGED = "DEVICE_INFO_LAYOUT_CHANGED";

/**
 * Dispatched whenever touch is enabled/desabled.
 */
export const TOUCH_CHANGED = "DEVICE_INFO_TOUCH_CHANGED";

/**
 * Dispatched whenever virtual keyboard is enabled/disabled
 */
export const VKB_CHANGED = "DEVICE_INFO_VKB_CHANGED";

/**
 * Dispatched whenever hover is applicable OR not applicable
 */
export const HOVER_CHANGED = `DEVICE_INFO_HOVER_CHANGED`;
